import { Col } from "react-bootstrap";
import './css/Project.css';
export const ProjectCard = ({ title, description, imgUrl , link}) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <a href={link}>
        <img src={imgUrl} alt={title}/>
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
        </a>
      
       
     
      </div>
    </Col>
  )
}
